import { useState } from "react";
import { api } from "@/lib/api";

export default function Nfc2ConvertPanel() {
    const [busy, setBusy] = useState(false);
    const [preview, setPreview] = useState(null);
    const [done, setDone] = useState(null);
    const [err, setErr] = useState(null);

    const run = async (fn) => {
        setBusy(true); setErr(null);
        try { await fn(); } catch (e) { setErr(e.response?.data?.detail || e.message); } finally { setBusy(false); }
    };
    const load = () => run(async () => setPreview((await api.get("/market/audit/nfc2-convert")).data));
    const convert = () => run(async () => {
        if (!window.confirm(`Convertire ${preview.count} etichette NFC in NFC2?`)) return;
        setDone((await api.post("/market/audit/nfc2-convert")).data);
        setPreview((await api.get("/market/audit/nfc2-convert")).data);
    });

    return (
        <div className="op-card p-5 mb-6 border-l-2" style={{ borderLeftColor: "rgb(var(--tc-2bb6ff))" }} data-testid="nfc2-convert-panel">
            <div className="flex items-end justify-between flex-wrap gap-3">
                <div className="flex-1 min-w-[200px]">
                    <div className="op-label text-t2bb6ff">// NFC2 · MERCATO DI RIPARAZIONE</div>
                    <p className="op-mono text-[11px] text-t8f95a3 mt-2 max-w-2xl leading-relaxed">
                        Le facce nuove arrivate in questa sessione prima dell&apos;introduzione di NFC2 hanno ancora NFC.
                        Qui le converti in NFC2 (si può ripetere: tocca solo chi è arrivato in questa sessione).
                    </p>
                </div>
                <button onClick={load} disabled={busy} data-testid="nfc2-preview"
                    className="op-btn px-4 py-2 border border-t2bb6ff/40 text-t2bb6ff disabled:opacity-50">
                    {busy ? "…" : "Mostra elenco"}
                </button>
            </div>
            {preview && (
                <div className="mt-4 pt-3 border-t border-t22252a" data-testid="nfc2-preview-result">
                    {!preview.active ? (
                        <div className="op-mono text-[12px] text-tc9ccd3">Nessuna sessione di riparazione aperta.</div>
                    ) : preview.count === 0 ? (
                        <div className="op-mono text-[12px] text-t7ce38b">✓ Nessuna etichetta da convertire.</div>
                    ) : (
                        <>
                            <ul className="space-y-1 max-h-72 overflow-y-auto pr-2">
                                {preview.items.map((it) => (
                                    <li key={it.entry_id} className="op-mono text-[12px]" data-testid={`nfc2-item-${it.entry_id}`}>
                                        <span className="text-tffffff">{it.player_name}</span>
                                        <span className="text-t8f95a3"> — {it.team_name}</span>
                                    </li>
                                ))}
                            </ul>
                            <button onClick={convert} disabled={busy} data-testid="nfc2-apply"
                                className="op-btn mt-3 px-4 py-2 border border-t2bb6ff/50 text-t2bb6ff disabled:opacity-50">
                                {busy ? "…" : `Converti in NFC2 (${preview.count})`}
                            </button>
                        </>
                    )}
                    {done && <div className="op-mono text-[12px] text-t7ce38b mt-2" data-testid="nfc2-apply-result">✓ Convertite {done.converted}.</div>}
                </div>
            )}
            {err && <div className="mt-3 text-xs text-tff3b30" data-testid="nfc2-error">{err}</div>}
        </div>
    );
}
